import React from "react"

import Carousel from "decentraland-gatsby/dist/components/Carousel/Carousel"
import ImgFixed from "decentraland-gatsby/dist/components/Image/ImgFixed"
import TokenList from "decentraland-gatsby/dist/utils/dom/TokenList"
import { useMobileMediaQuery } from "decentraland-ui/dist/components/Media/Media"

import loading from "../../images/loading.svg"
import { FeedProps } from "./types"
import { useFeedColumnName } from "./utils"
const DEFAULT_COLUMNS = 3

export type LoadingProps = React.HTMLProps<HTMLAnchorElement>

export type LoadingFeedProps = React.HTMLProps<HTMLDivElement> & FeedProps

export default React.memo(function LoadingFeed({ columns }: LoadingFeedProps) {
  columns = columns || DEFAULT_COLUMNS
  const isMobile = useMobileMediaQuery()
  const columnClassName = useFeedColumnName(columns, DEFAULT_COLUMNS)

  return (
    <Carousel className="Feed">
      <div className="Feed__List">
        {Array.from(Array(isMobile ? 1 : columns)).map((_, i) => {
          return (
            <LoadingItem key={`loading::${i}`} className={columnClassName} />
          )
        })}
      </div>
    </Carousel>
  )
})

export const LoadingItem = React.memo(function LoadingItemComponent(
  props: LoadingProps
) {
  return (
    <a {...props} className={TokenList.join(["Feed__Item", props.className])}>
      <ImgFixed dimension="square" src={loading} />
    </a>
  )
})

export const LoadingBlogItem = React.memo(function LoadingBlogItemComponent(
  props: LoadingProps
) {
  return (
    <a {...props} className={TokenList.join(["Feed__Item", props.className])}>
      <ImgFixed dimension="wide" src={loading} />
      <div className="Feed__Item__Description">
        <div className="Fake__Paragraph">
          <div className="Fake__Date" />
          <div className="Fake__Tag" />
        </div>
        <div className="Fake__SubTitle" />
      </div>
    </a>
  )
})
